export const state = () => ({
    configBgImgDefault: {
        backgroundImage: '',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '',
        height: ''
    }
});

export const getters = {
    configBgImgDefault: (state) => state.configBgImgDefault
};

export const actions = {
    registerDataEditor({ commit }, data) {
        commit('handleRegisterDataEditor', data);
    }
};

export const mutations = {
    handleRegisterDataEditor(state, data) {
        let { backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat, width, height } = data;
        state.configBgImgDefault = {
            backgroundImage: backgroundImage ?? '',
            backgroundSize: backgroundSize ?? 'cover',
            backgroundPosition: backgroundPosition ?? 'center',
            backgroundRepeat: backgroundRepeat ?? 'no-repeat',
            width: width ?? '100%',
            height: height ?? '100%'
        };
    }
};
